import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { TransferModel } from '../../Models/Models/Transfer/TransferModel';

declare var IS_RUNNING_IN_APP_POOL;

export class ProductTransfersInClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string): Promise<Array<TransferModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/ProductTransfersIn/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<Array<TransferModel>, any>(url, data);
  }
}

